import React from 'react';

import { UseQueryResult } from '@tanstack/react-query';
import { Link } from '~/lib/react-router-dom';

import { Alert, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';

import { RateGroup } from '~/services/cruises/RateGroupService';

import RateGroupAccordion from './RateGroupAccordion';

interface Props {
  rateGroupsQuery: UseQueryResult<Array<RateGroup>, Error>;
  vendorId: string | undefined;
}

function RateGroupList({ rateGroupsQuery, vendorId }: Props) {
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" fontWeight={700} mb={2}>
          Current rate groups
        </Typography>

        {rateGroupsQuery.isLoading && <CircularProgress size={24} aria-label="Loading rate groups" />}
        {rateGroupsQuery.isError && <Alert severity="error">Unable to load rate groups.</Alert>}
        {!rateGroupsQuery.isLoading && !rateGroupsQuery.isError && rateGroupsQuery.data?.length === 0 && (
          <Typography>No rate groups found.</Typography>
        )}
        {!rateGroupsQuery.isLoading && !rateGroupsQuery.isError && rateGroupsQuery.data && (
          <Stack spacing={1}>
            {rateGroupsQuery.data.map((rateGroup) => (
              <RateGroupAccordion key={rateGroup.id} rateGroup={rateGroup} vendorId={vendorId} />
            ))}
          </Stack>
        )}
        {!rateGroupsQuery.isLoading && !rateGroupsQuery.isError && vendorId && (
          <Button
            component={Link}
            to={`/cruises/rate-grouping?vendorId=${vendorId}`}
            variant="outlined"
            fullWidth
            target="_blank"
            rel="noreferrer"
            sx={{ mt: 2 }}
          >
            Manage rate groups
          </Button>
        )}
      </CardContent>
    </Card>
  );
}

export default RateGroupList;
